import React from 'react';
import { useFormState } from 'react-hook-form';
import { TableFilterButtons, TableFilterCard, TableFilterSection } from '@repo/ui/Table';
import { TextInputField } from '@repo/ui/Form';
import { registerInput } from '@repo/hooks/useZodForm';
import { useZodFormContext } from '@repo/hooks/useZodFormContext';

const SwitchesTableFilter = () => {
  const filter = useZodFormContext();
  useFormState();
  if (!filter) {
    return <></>;
  }

  return (
    <TableFilterCard>
      <TableFilterSection>
        <TextInputField label="Switch Name" {...registerInput(filter, 'name')} />
      </TableFilterSection>

      <TableFilterButtons className="self-end" />
    </TableFilterCard>
  );
};

export default SwitchesTableFilter;
